import w from "axios";
import { StorageKeyEnum as i } from "../const/StorageKeyEnum.js";
import a from "localforage";
import { refreshTokenUrl as I, refreshAccessToken as m } from "./auth/index.js";
let c = null;
class E {
  instance;
  static getInstance() {
    if (!c)
      throw new Error("Request instance is not initialized");
    return c;
  }
  static initRequest(t) {
    if (t)
      c = new E(t);
    else
      throw new Error("Initialization baseUrl is required");
  }
  constructor(t, n = 6e4) {
    const s = w.create({
      baseURL: t,
      timeout: n
    });
    s.interceptors.request.use(async (e) => {
      console.log("config: ", e);
      let r = null;
      if (console.log("refreshTokenUrl: ", I), console.log("config.url: ", e.url), e.url === I)
        r = await a.getItem(i.ADMIN_REFRESH_TOKEN);
      else {
        const o = await a.getItem(i.ADMIN_TOKEN);
        if (o) {
          const l = await a.getItem(i.ADMIN_TOKEN_EXPIRE_TIME);
          console.log("expireTime: ", l), l && new Date(l) < /* @__PURE__ */ new Date() ? (await m(), r = await a.getItem(i.ADMIN_TOKEN)) : r = o, console.log("token: ", r);
        }
      }
      return !e.headers.Authorization && r && (e.headers.Authorization = `Bearer ${r}`), e;
    });
    const u = async (e, r) => {
      if (!e || !e.code)
        return null;
      if (e.code === -1e4) {
        try {
          await m();
          const o = await a.getItem(i.ADMIN_TOKEN);
          if (o && r)
            return r.headers.Authorization = `Bearer ${o}`, s.request(r);
        } catch (o) {
          console.error("Token refresh failed:", o), await a.removeItem(i.ADMIN_TOKEN), await a.removeItem(i.ADMIN_REFRESH_TOKEN), await a.removeItem(i.ADMIN_TOKEN_EXPIRE_TIME), window.location.href = "/login";
        }
        return;
      }
      if (e.code === -2e4) {
        console.warn("Refresh token expired, redirecting to login"), await a.removeItem(i.ADMIN_TOKEN), await a.removeItem(i.ADMIN_REFRESH_TOKEN), await a.removeItem(i.ADMIN_TOKEN_EXPIRE_TIME), window.location.href = "/login";
        return;
      }
      return null;
    };
    s.interceptors.response.use(
      async (e) => {
        const r = e.data, o = await u(r, e.config);
        return o !== null ? o : r;
      },
      async (e) => {
        if (e.response?.status === 401)
          return localStorage.removeItem(i.ADMIN_TOKEN), window.location.href = "/login", Promise.reject(e);
        const r = e.response?.data, o = await u(r, e.config);
        if (o !== null)
          return o;
        throw e.response?.data || e;
      }
    ), this.instance = s;
  }
  request(t, n, s) {
    return this.instance.request({
      url: t,
      method: n,
      ...s
    });
  }
  get = (t, n, s, u) => this.request(t, "GET", {
    params: n,
    headers: s,
    paramsSerializer: u
  });
  post = (t, n, s) => this.request(t, "POST", { data: n, headers: s });
  put = (t, n, s) => this.request(t, "PUT", { data: n, headers: s });
  del = (t, n) => this.request(t, "DELETE", { data: n });
  patch = (t, n) => this.request(t, "PATCH", { data: n });
}
const _ = E.getInstance;
export {
  E as default,
  _ as http
};
